enum Paths {
    dashboard = '/dashboard',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/Dashboard/paths.ts